'use strict'
import {bootstrap} from '../bootstrap/bootstrap'
import {addLogoInteractionHandler, attachHamburgerHandler} from './handlers'
import {onScroll} from './scrolling'

const logo = document.querySelector('svg.logo')
const hamburger = document.querySelector('nav.navigation .hamburger')
const mobileNav = document.querySelector('nav.navigation__mobile')

bootstrap(logo, addLogoInteractionHandler)
bootstrap(hamburger, attachHamburgerHandler, mobileNav)
bootstrap(window, (el, event, callback) => el.addEventListener(event, callback), 'scroll', onScroll)
